/**
 * 运营策略工具函数
 */
import dayjs from 'dayjs';
import { StrategyPhase, WeeklyStrategy } from '../ProfitScenario/types';

/**
 * 创建初始周策略
 */
export const createWeekStrategy = (
    weekNumber: number,
    basePrice: number = 39.99,
    dailyUnits: number = 20
): WeeklyStrategy => ({
    weekNumber,
    basePrice,
    dailyUnits,
    enablePrime: false,
    primeDiscount: 0,
    enableCoupon: false,
    couponDiscount: 0,
    enablePromotion: false,
    promotionDiscount: 0,
    enableLightningDeal: false,
    lightningDealDiscount: 0,
    enableAds: true,
    cpc: 1.5,
    cvr: 5,
    adSalesRatio: 30
});

/**
 * 创建初始阶段
 */
export const createInitialPhase = (): StrategyPhase => ({
    id: '1',
    name: '新品推广期',
    startWeek: 1,
    endWeek: 4,
    weeks: Array.from({ length: 4 }, (_, i) => createWeekStrategy(i + 1))
});

/**
 * 计算结束日期
 */
export const calculateEndDate = (startDate: string, weekCount: number): string => {
    const start = dayjs(startDate);
    const days = (weekCount - 1) * 7 + 6; // (n-1)×7 + 6天
    return start.add(days, 'day').format('YYYY-MM-DD');
};

/**
 * 重新生成周策略数组（当时间范围改变时）
 */
export const regenerateWeeks = (
    startWeek: number,
    endWeek: number,
    existingWeeks: WeeklyStrategy[]
): WeeklyStrategy[] => {
    const weekCount = endWeek - startWeek + 1;
    const newWeeks: WeeklyStrategy[] = [];

    for (let i = 0; i < weekCount; i++) {
        const weekNumber = startWeek + i;
        const existingWeek = existingWeeks.find(w => w.weekNumber === weekNumber);

        if (existingWeek) {
            newWeeks.push(existingWeek);
        } else {
            const prevWeek = newWeeks[i - 1] || existingWeeks[0];
            newWeeks.push(prevWeek ? {
                ...prevWeek,
                weekNumber
            } : createWeekStrategy(weekNumber));
        }
    }

    return newWeeks;
};
